module.exports = __webpack_public_path__ + "img/loader_white.ad8ab8cd.svg";